import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

/**
 * When the system just starts, the local devices are muted.
 * We mute the camera, microphone andspeaker in createLocalDeviceLifecycle function.
 * If you dont place this function in the call page, the call will not work.
 */
export function useManageDevicesStatus(): void {
  const { vidyoSDK, isCameraMuted, isMicrophoneMuted, isSpeakerMuted } =
    useVidyoStore(
      useShallow((state) => ({
        vidyoSDK: state.vidyoSDK,
        isCameraMuted: state.camera.shouldBeMuted,
        isMicrophoneMuted: state.microphone.shouldBeMuted,
        isSpeakerMuted: state.speaker.shouldBeMuted,
      })),
    );

  useEffect(() => {
    if (!vidyoSDK) return;
    const init = async () => {
      await vidyoSDK.SetCameraPrivacy({
        privacy: isCameraMuted,
      });
    };
    init();

    return () => {
      vidyoSDK.SetCameraPrivacy({ privacy: true });
    };
  }, [isCameraMuted, vidyoSDK]);

  useEffect(() => {
    if (!vidyoSDK) return;
    const init = async () => {
      await vidyoSDK.SetMicrophonePrivacy({
        privacy: isMicrophoneMuted,
      });
    };
    init();

    return () => {
      vidyoSDK.SetMicrophonePrivacy({ privacy: true });
    };
  }, [isMicrophoneMuted, vidyoSDK]);

  useEffect(() => {
    if (!vidyoSDK) return;
    const init = async () => {
      await vidyoSDK.SetSpeakerPrivacy({
        privacy: isSpeakerMuted,
      });
    };
    init();

    return () => {
      vidyoSDK.SetSpeakerPrivacy({ privacy: true });
    };
  }, [isSpeakerMuted, vidyoSDK]);
}
